export enum PhaseType {
	REFLECT = 'REFLECT',
	PREPARE = 'PREPARE',
	CARRY_OUT = 'CARRY_OUT',
}
